<template>
    <div class="kucsc">
        <div class="kucsc__headers">
            <div class="row">
                <div class="col-6 col-md-8">
                    KUCSC Student Optional Fees
                    <div v-if="!admin" class="fee__info mb-1">
                        KUCSC encourages you to take a moment to watch this short video to demonstrate some of the
                        services
                        they provide to King's students -- <a href="https://www.youtube.com/watch?v=9qnKJr79VMQ&t"
                            target="_blank">https://www.youtube.com/watch?v=9qnKJr79VMQ&t</a>.
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    Value
                </div>
                <div class="col-3 col-md-2">
                    Opt-Out
                </div>
            </div>
        </div>
        <div class="kucsc__fees">
            <div class="row mb-2" :class="[{ 'opt__out' : administrationCommunications.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            Administration & Communications
                        </div>
                        <div v-if="!admin" class="fee__info">This fee ensures that the KUCSC can operate smoothly from
                            an
                            administrative perspective throughout the year. Includes essential fees, such as Lawyer
                            Fees, Accountant Fees, Insurance, Printer Expenses, Office Supplies, Executive Honoraria,
                            Associate Honoraria, Promotion & Advertising, and Computer Software.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ administrationCommunications.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="kucsc-administration-communications"
                            name="kucsc-administration-communications" value="opt-out"
                            v-model="administrationCommunications.optOut" @change="optOut(administrationCommunications)"
                            aria-label="administration and communications" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : studentProgramming.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Student Programming
                        </div>
                        <div v-if="!admin" class="fee__info">
                            This fee helps the KUCSC ensure that your time at King’s is filled with interesting, fun and
                            fulfilling student events. Includes King's Players Theatre Company, President's Initiative
                            (such as electoral debates & the Accessible Menstruation Initiative), Relay for Life, First
                            Year Off Campus Programming, Charity Events, King's Ball, Grad Ball, Head Soph Team
                            Honoraria and Uniforms, Soph Team Training, O-Week Programming, O-Week Food.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ studentProgramming.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="kucsc-student-programming" value="opt-out"
                            name="kucsc-student-programming" v-model="studentProgramming.optOut"
                            aria-label="student programming" @change="optOut(studentProgramming)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : wusc.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            WUSC
                        </div>
                        <div v-if="!admin" class="fee__info">
                            As decided in the 2018-2019 referendum, the World University Service of Canada (WUSC)
                            Student Refugee Program fee empowers students, faculty and staff to sponsor young refugees
                            to resettle in Canada and continue their education. Includes WUSC Student Levy, Local
                            Committee Operating Fund.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ wusc.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="kucsc-wusc" name="kucsc-wusc" value="opt-out" v-model="wusc.optOut"
                            aria-label="WUSC" @change="optOut(wusc)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : studentAffairs.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Student Affairs
                        </div>
                        <div v-if="!admin" class="fee__info">This fee ensures that your voice as a student is heard,
                            through various
                            initiatives and programs. Includes Volunteer Fair, Volunteer Programs, Environmental Week,
                            Community Garden, Diversity and Inclusion Programming, Wellness Programming, and Speaker
                            Series.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ studentAffairs.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="kucsc-student-affairs" name="kucsc-student-affairs" value="opt-out"
                            aria-label="student affairs" v-model="studentAffairs.optOut"
                            @change="optOut(studentAffairs)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : servicesFacilities.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title">
                        <div class="fee__header">
                            Services & Facilities
                        </div>
                        <div v-if="!admin" class="fee__info">
                            This fee includes the King's Connection, which allows students access to King’s branded
                            merchandise, as well as acts as a hub for students to purchase event tickets. This fee also
                            includes the Sports Pad (the rink behind residence) and the Games Room located in the SLC.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value">
                        $ {{ servicesFacilities.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check">
                        <input type="checkbox" id="kucsc-services-facilities" name="kucsc-services-facilities"
                            aria-label="services and facilities" value="opt-out" v-model="servicesFacilities.optOut"
                            @change="optOut(servicesFacilities)" :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row mb-2" :class="[{ 'opt__out' : studentClubs.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="form__fee-title-even">
                        <div class="fee__header">
                            Student Clubs
                        </div>
                        <div v-if="!admin" class="fee__info">
                            This fee gives students access to join and enjoy over 30 clubs on King’s campus. IF YOU
                            CHOOSE TO OPT-OUT OF THIS FEE YOU WILL NOT BE ABLE TO JOIN OR PARTICIPATE IN KING’S CLUBS.
                        </div>
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form__fee-value-even">
                        $ {{ studentClubs.amount }}
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check form__fee-check-even">
                        <input type="checkbox" id="kucsc-student-clubs" name="kucsc-student-clubs" value="opt-out"
                            aria-label="student clubs" v-model="studentClubs.optOut" @change="optOut(studentClubs)"
                            :disabled="submitted">
                    </div>
                </div>
            </div>
            <div class="row" :class="[{ 'opt__out' : nonAcademicRepresentatives.optOut }]">
                <div class="col-6 col-md-8">
                    <div class="fee__header">
                        Non-Academic Representatives
                    </div>
                    <div v-if="!admin" class="fee__info">
                        This fee helps KUCSC Representatives ensure that the voices of King’s students are heard
                        throughout all areas of campus. Positions such as Accessibility Representative, Indigenous
                        Students Representatives, and International Students Representatives work towards creating an
                        inclusive and empowering campus.
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    $ {{ nonAcademicRepresentatives.amount }}
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check">
                        <input type="checkbox" id="kucsc-nonacademic-representatives"
                            name="kucsc-nonacademic-representatives" value="opt-out"
                            v-model="nonAcademicRepresentatives.optOut" @change="optOut(nonAcademicRepresentatives)"
                            aria-label="non-academic representatives" :disabled="submitted">
                    </div>
                </div>
            </div>
        </div>
        <div :class="[total > 0 ? 'kucsc__fee' : 'kucsc__nofee', 'kucsc__total']">
            <div class="row">
                <div class="col-6 col-md-8">
                    Total KUCSC Optional Fees
                </div>
                <div class="col-6 col-md-4">
                    $ {{ total }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'form-kucsc',
    props: {
        admin: {
            type: Boolean
        },
        userData: {
            type: Object
        },
        submitted: {
            type: Boolean
        }
    },
    data() {
        return {
            administrationCommunications: {
                amount: "18.54",
                optOut: false
            },
            studentProgramming: {
                amount: "19.69",
                optOut: false
            },
            wusc: {
                amount: "6.28",
                optOut: false
            },
            studentAffairs: {
                amount: "10.54",
                optOut: false
            },
            servicesFacilities: {
                amount: "17.04",
                optOut: false
            },
            studentClubs: {
                amount: "5.72",
                optOut: false
            },
            nonAcademicRepresentatives: {
                amount: "3.50",
                optOut: false
            },
            total: "0.00"
        }
    },
    methods: {
        optOut(fee) {
            // Opt-out calcuation
            if (!fee.optOut) {
                this.total = Number.parseFloat(this.total) + Number.parseFloat(fee.amount);
            } else {
                this.total = Number.parseFloat(this.total) - Number.parseFloat(fee.amount);
            }

            // Currency parse and format
            this.total = Number.parseFloat(this.total).toFixed(2);

            // Update sci total fees
            this.$emit('getKucscTotal', this.total);
        },
        getFee(fee) {
            if (fee.match(/communications$/i)) {
                return this.administrationCommunications;
            } else if (fee.match(/programming$/i)) {
                return this.studentProgramming;
            } else if (fee.match(/wusc$/i)) {
                return this.wusc;
            } else if (fee.match(/affairs$/i)) {
                return this.studentAffairs;
            } else if (fee.match(/facilities$/i)) {
                return this.servicesFacilities;
            } else if (fee.match(/clubs$/i)) {
                return this.studentClubs;
            } else if (fee.match(/representatives$/i)) {
                return this.nonAcademicRepresentatives;
            } else {
                return false;
            }
        },
        getTotalFees() {
            // Total float calculation
            this.total =
                Number.parseFloat(this.administrationCommunications.amount) +
                Number.parseFloat(this.studentProgramming.amount) +
                Number.parseFloat(this.wusc.amount) +
                Number.parseFloat(this.studentAffairs.amount) +
                Number.parseFloat(this.servicesFacilities.amount) +
                Number.parseFloat(this.studentClubs.amount) +
                Number.parseFloat(this.nonAcademicRepresentatives.amount);

            // Curreny Format
            this.total = Number.parseFloat(this.total).toFixed(2);
        }
    },
    created() {
        // Total KUCSC Optional Fees
        this.getTotalFees();

        // Update sci total fees
        this.$emit('getKucscTotal', this.total);

        // Formdata handler
        if (this.userData.result && this.userData.result.match(/^OK/i)) {
            if (this.userData.data && this.userData.data.length > 0) {
                let formData = this.userData.data;

                formData.forEach((record) => {
                    let key = record.key;
                    let fee = this.getFee(key);

                    if (fee) {
                        fee.optOut = true;
                        this.optOut(fee);
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.kucsc {
    margin-bottom: 1.25rem;
}

.kucsc__fees {
    border-bottom: 1px solid black;
    padding-bottom: .5rem;
}

.kucsc__headers {
    font-size: 16px;
    font-weight: 600;
}

.kucsc__total {
    font-size: 16px;
    font-weight: 600;
}

.kucsc__fee {
    color: #3455db;
}

.kucsc__nofee {
    color: #008040;
}
</style>